
export class Puser {
    patientId: string;
    welcomeMsg:string;
    patSWFId: string;
    admittedDate: number;
    surgeonName: string;
    serviceLineId: string;
    serviceLineLabel: string;
    laterality: string;
    practiceLogo: string;
    firstLogin: boolean;
    currentStageId:number;
    procedureType:string;    
    procedureTypedisplay: string;
    lateralitydisplay: string;
  }
  